const EsMetIcon = ({ ...props }) => (
  <svg
    fill="none"
    height="39"
    viewBox="0 0 39 39"
    width="39"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1574_9163)">
      <path
        d="M38.4 19.2C38.4 29.7984 29.7984 38.4 19.2 38.4C8.6016 38.4 0 29.7984 0 19.2C0 8.6016 8.6016 0 19.2 0C29.7984 0 38.4 8.6016 38.4 19.2Z"
        fill="url(#paint0_linear_1574_9163)"
      />
      <path
        d="M26.3676 11.917H20.1596V14.0802C19.5324 12.8002 18.214 11.9298 16.6908 11.9298H8.16602V26.4834H10.8924V14.6562H16.8572C17.3948 14.6562 17.83 15.0914 17.83 15.629V26.4834H20.5564V15.7954C20.5564 15.3986 20.4924 15.0146 20.39 14.6562H26.534C27.0716 14.6562 27.5068 15.0914 27.5068 15.629V26.4834H30.2332V15.7954C30.2332 13.6578 28.5052 11.917 26.3676 11.917Z"
        fill="white"
      />
      <circle
        cx="32.6399"
        cy="32.6399"
        fill="white"
        r="5.25219"
        stroke="#259DA8"
        strokeWidth="1.01562"
      />
      <path
        d="M31.4134 34.6497C31.0981 34.6497 30.8261 34.5801 30.5974 34.4409C30.3701 34.3003 30.1947 34.1043 30.0711 33.8528C29.949 33.6 29.8879 33.306 29.8879 32.9707C29.8879 32.6355 29.949 32.3401 30.0711 32.0844C30.1947 31.8273 30.3666 31.627 30.5867 31.4835C30.8083 31.3386 31.0669 31.2662 31.3623 31.2662C31.5328 31.2662 31.7011 31.2946 31.8673 31.3514C32.0335 31.4082 32.1847 31.5006 32.3211 31.6284C32.4575 31.7548 32.5661 31.9225 32.6471 32.1313C32.7281 32.3401 32.7686 32.5972 32.7686 32.9026V33.1156H30.2458V32.681H32.2572C32.2572 32.4963 32.2203 32.3315 32.1464 32.1867C32.074 32.0418 31.9703 31.9274 31.8353 31.8436C31.7018 31.7598 31.5441 31.7179 31.3623 31.7179C31.162 31.7179 30.9887 31.7676 30.8424 31.8671C30.6975 31.9651 30.586 32.0929 30.5079 32.2506C30.4298 32.4082 30.3907 32.5773 30.3907 32.7577V33.0475C30.3907 33.2946 30.4333 33.5041 30.5186 33.676C30.6052 33.8465 30.7252 33.9764 30.8786 34.0659C31.032 34.154 31.2103 34.198 31.4134 34.198C31.5455 34.198 31.6649 34.1796 31.7714 34.1426C31.8794 34.1043 31.9724 34.0475 32.0505 33.9722C32.1286 33.8955 32.189 33.8003 32.2316 33.6867L32.7174 33.823C32.6663 33.9878 32.5803 34.1327 32.4596 34.2577C32.3389 34.3813 32.1897 34.4778 32.0122 34.5475C31.8346 34.6156 31.635 34.6497 31.4134 34.6497ZM35.8517 32.0418L35.3999 32.1696C35.3715 32.0943 35.3296 32.0212 35.2742 31.9502C35.2203 31.8777 35.1464 31.818 35.0526 31.7712C34.9589 31.7243 34.8389 31.7009 34.6926 31.7009C34.4923 31.7009 34.3254 31.747 34.1919 31.8394C34.0597 31.9303 33.9937 32.046 33.9937 32.1867C33.9937 32.3117 34.0392 32.4104 34.1301 32.4828C34.221 32.5553 34.363 32.6156 34.5562 32.6639L35.042 32.7832C35.3346 32.8543 35.5526 32.9629 35.6961 33.1092C35.8396 33.2541 35.9113 33.4409 35.9113 33.6696C35.9113 33.8571 35.8573 34.0247 35.7494 34.1725C35.6428 34.3202 35.4937 34.4367 35.3019 34.5219C35.1102 34.6071 34.8872 34.6497 34.6329 34.6497C34.2991 34.6497 34.0228 34.5773 33.8041 34.4324C33.5853 34.2875 33.4468 34.0759 33.3886 33.7975L33.8659 33.6781C33.9113 33.8543 33.9972 33.9864 34.1237 34.0744C34.2515 34.1625 34.4184 34.2065 34.6244 34.2065C34.8588 34.2065 35.0448 34.1568 35.1826 34.0574C35.3218 33.9565 35.3914 33.8358 35.3914 33.6952C35.3914 33.5815 35.3517 33.4864 35.2721 33.4097C35.1926 33.3315 35.0704 33.2733 34.9056 33.235L34.3602 33.1071C34.0605 33.0361 33.8403 32.926 33.6997 32.7769C33.5605 32.6263 33.4909 32.4381 33.4909 32.2122C33.4909 32.0276 33.5427 31.8642 33.6464 31.7222C33.7515 31.5801 33.8943 31.4686 34.0747 31.3877C34.2565 31.3067 34.4624 31.2662 34.6926 31.2662C35.0164 31.2662 35.2707 31.3372 35.4553 31.4793C35.6414 31.6213 35.7735 31.8088 35.8517 32.0418Z"
        fill="#259DA8"
      />
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_1574_9163"
        x1="5.62355"
        x2="32.7764"
        y1="5.62355"
        y2="32.7764"
      >
        <stop stopColor="#4BD5D8" />
        <stop offset="1" stopColor="#3C4257" />
      </linearGradient>
      <clipPath id="clip0_1574_9163">
        <rect fill="white" height="38.4" width="38.4" />
      </clipPath>
    </defs>
  </svg>
)

export default EsMetIcon
